import { createSelector } from 'reselect';

export default ({
  getField: state => state.modalField.field,
  getOptionsIds: state => state.modalField.field.optionsIds,
  getCheckPoints: state => state.modalField.field.checkPoints,
  getEmptyPointsWarning: state => state.modalField.field.emptyPointsWarning,
  getOptionsIndexed: state => state.modalField.optionsIndexed,
  getOptionsIndexedById: (state, optionId) => state.modalField.optionsIndexed[optionId],
  getDefaultExams: state => state.modalField.defaultExams,
  getContext: state => state.modalField.context,
  getFormOrigin: state => state.modalField.formOrigin,

  getSwipeIndex: createSelector(
    state => state.modalField.swipe.index,
    state => state
  ),
  getFieldDataType: createSelector(
    state => state.modalField.field.dataType,
    state => state
  ),
  getFieldModelId: createSelector(
    state => state.modalField.field.fieldModelId,
    state => state
  ),
  getEnableObservation: createSelector(
    state => state.modalField.field.enableObservation,
    state => state
  ),
  getEnablePeriodInterval: createSelector(
    state => state.modalField.field.enablePeriodInterval,
    state => state
  ),
  getRangeMin: createSelector(
    state => state.modalField.field.rangeMin,
    state => state
  ),
  getRangeMax: createSelector(
    state => state.modalField.field.rangeMax,
    state => state
  ),
  getScoreMax: createSelector(
    state => state.modalField.field.scoreMax,
    state => state
  ),
  getTypePainMapBody: createSelector(
    state => state.modalField.field.typePainMapBody,
    state => state
  ),
  getTextInfoRangeMin: createSelector(
    state => state.modalField.field.textInfoMin,
    state => state
  ),
  getTextInfoRangeMax: createSelector(
    state => state.modalField.field.textInfoMax,
    state => state
  ),
  getTabDisaginerDisabled: createSelector(
    state => state.modalField.tabDesignerDisabled,
    state => state
  ),
  getEnableNewLine: createSelector(
    state => state.modalField.field.enableNewLine,
    state => state
  ),
  getEnableNewPage: createSelector(
    state => state.modalField.field.enableNewPage,
    state => state
  ),
  getEnableInline: createSelector(
    state => state.modalField.field.enableInline,
    state => state
  ),
  getEnableSelectListDesign: createSelector(
    state => state.modalField.field.enableSelectListDesign,
    state => state
  ),
  getFieldSize: createSelector(
    state => state.modalField.field.size,
    state => state
  ),
  getFieldTitle: createSelector(
    state => state.modalField.field.title,
    state => state
  ),
  getFieldTitleDisplay: createSelector(
    state => state.modalField.field.displayName,
    state => state
  ),
  getFieldMuscleStrength: createSelector(
    state => state.modalField.field.typeMuscleStrength,
    state => state
  ),
  getFieldTitleDisplayHtml: createSelector(
    state => state.modalField.field.displayNameHtml,
    state => state
  ),
  getFieldImagesDefault: createSelector(
    state => state.modalField.field.imagesDefault,
    state => state
  ),
  getIsImageDefault: createSelector(
    state => state.modalField.field.isImageDefault,
    state => state
  ),
  getUrlImagesDefault: createSelector(
    state => state.modalField.field.urlImagesDefault,
    state => state
  ),
  getCategoriesImages: createSelector(
    state => state.modalField.field.categoriesImagesIds,
    state => state
  ),
  getFieldImages: createSelector(
    state => state.modalField.field.images,
    state => state
  ),
  getFieldIsEditText: createSelector(
    state => state.modalField.field.isEditText,
    state => state
  ),
  getFieldMeasurementUnit: createSelector(
    state => state.modalField.field.measurementUnit,
    state => state
  ),
  getFieldIsModelField: createSelector(
    state => state.modalField.field.isModelField,
    state => state
  ),
  getFieldDescription: createSelector(
    state => state.modalField.field.description,
    state => state
  ),
  getApiExamSearch: createSelector(
    state => state.modalField.api.examSearch,
    state => state
  ),
  getIsFetchingExamSearch: createSelector(
    state => state.modalField.fetching.examSearch,
    state => state
  ),
  getIsFetchingSave: createSelector(
    state => state.modalField.fetching.saveField,
    state => state
  ),
  getIsFetchingFieldById: createSelector(
    state => state.modalField.fetching.getFieldById,
    state => state
  ),
  getIsEditLoading: createSelector(
    state => state.modalField.fetching.editField,
    state => state
  ),
  getFetchUpdateFieldModelById: createSelector(
    state => state.modalField.fetching.updateFieldModelById,
    state => state
  ),
  getFetchUploadImageInfoLabel: createSelector(
    state => state.modalField.fetching.uploadImageInfoLabel,
    state => state
  ),
  getIsViewOnly: createSelector(
    state => state.modalField.viewOnly,
    state => state
  ),
  getScoreRangeMin: createSelector(
    state => state.modalField.field.scoreMin,
    state => state
  ),
  getScoreRangeMax: createSelector(
    state => state.modalField.field.scoreMax,
    state => state
  ),
  getQualifier: createSelector(
    state => state.modalField.field.qualifier,
    state => state
  ),
  getQualifierDeficiency: createSelector(
    state => state.modalField.field.qualifierDeficiency,
    state => state
  ),
  getQualifierId: createSelector(
    state => state.modalField.field.qualifierId,
    state => state
  ),
  getQualifierDeficiencyId: createSelector(
    state => state.modalField.field.qualifierDeficiencyId,
    state => state
  ),
  getReferenceField: createSelector(
    state => state.modalField.field.referenceField,
    state => state
  ),
  getAnalyzeBetter: createSelector(
    state => state.modalField.field.analyzeBetter,
    state => state
  ),
  getTypeScore: createSelector(
    state => state.modalField.field.typeScore,
    state => state
  ),
  getDeficiencyCalc: createSelector(
    state => state.modalField.field.deficiencyCalc,
    state => state
  ),
  getTypeReference: createSelector(
    state => state.modalField.field.typeReference,
    state => state
  ),
  getEnableConfigScore: createSelector(
    state => state.modalField.field.configScore,
    state => state
  ),
  getQualifiers: createSelector(
    state => state.modalField.qualifiers,
    state => state
  ),
  getCategoriesFiles: createSelector(
    state => state.modalField.categoriesFiles,
    state => state
  )
});